module.exports = __webpack_public_path__ + "img/section4_1.9561ea77.png";